import { clientConfigFn } from "clientConfig";
export const NumberPercentage = (props) => {
    return (props.number / 100).toLocaleString(clientConfigFn().currencyLocale, {
        style: "percent",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};
